import React from 'react';
export function Footer() {
  return <footer className="w-full py-12 px-4 sm:px-6 lg:px-8 border-t border-brand-cyan/20" data-id="element-127">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-128">
        <h3 className="text-brand-cyan font-bold text-lg mb-2" data-id="element-129">
          Mega Pack: Cuenta Blindada
        </h3>
        <p className="text-gray-400 text-sm mb-6" data-id="element-130">
          Sistema de seguridad digital para argentinos con cuentas bancarias y
          billeteras virtuales
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 text-gray-500 text-sm mb-8" data-id="element-131">
          <span data-id="element-132">@infinitamente.digital</span>
          <span className="hidden sm:inline" data-id="element-133">•</span>
          <span data-id="element-134">soporteinfinitamente@gmail.com</span>
        </div>

        <p className="text-gray-600 text-xs mb-4" data-id="element-135">
          © 2026 InfinitaMenteDigital. Todos los derechos reservados.
        </p>

        <p className="text-gray-700 text-[10px] max-w-2xl" data-id="element-136">
          Este producto tiene carácter exclusivamente educativo e informativo.
          No constituye asesoramiento profesional en ciberseguridad.
        </p>
      </div>
    </footer>;
}